import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/services/api.service';
import { SynopsisPopupComponent } from '../synopsis-popup/synopsis-popup.component';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css'],
})
export class FeedbackComponent {
  constructor(
    private dialogRef: MatDialogRef<SynopsisPopupComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: string,
    private snackbar: MatSnackBar,
    private api: ApiService
  ) {}

  buttonClicked: boolean = false;
  comment: string = '';
  rating: number = 5;

  ngOnInit() {
    this.dialogRef.keydownEvents().subscribe((event) => {
      if (event.key === 'Escape') {
        this.dialogRef.close();
      }
    });
  }

  selectRating(value: number) {
    this.rating = value + 1;
  }

  submit() {
    this.buttonClicked = true;
    this.api
      .reportsFeedback({
        id: this.data,
        feedback: this.comment,
        rating: this.rating,
      })
      .subscribe(
        (data: any) => {
          this.buttonClicked = false;
          if (data.status) {
            this.dialogRef.close(data.data.reportid);
            this.snackbar.open(data.message, undefined, {
              duration: 5000,
              panelClass: 'success',
            });
          } else {
            this.snackbar.open(data.message, undefined, {
              duration: 5000,
              panelClass: 'failure',
            });
          }
        },
        (error) => {
          this.buttonClicked = false;
        }
      );
  }
}
